document.addEventListener('DOMContentLoaded', function () {
  const noticeId = 'number11-aop-delay-notice';

  if (document.getElementById(noticeId)) return;

  const wrapper = document.createElement('div');
  wrapper.id = noticeId;

  wrapper.innerHTML = `
    <style>
      #number11-aop-delay-notice {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 9999;
        font-family: inherit;
      }

      .number11-delay-trigger {
        width: 48px;
        height: 48px;
        border: 0;
        border-radius: 50%;
        background: #111;
        color: #fff;
        font-size: 28px;
        font-weight: 700;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
      }

      .number11-delay-bubble {
        position: absolute;
        right: 0;
        bottom: 62px;
        width: min(320px, calc(100vw - 40px));
        padding: 18px 20px;
        background: #fff;
        color: #111;
        border: 2px solid #111;
        border-radius: 16px;
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
      }

      .number11-delay-bubble::after {
        content: '';
        position: absolute;
        right: 16px;
        bottom: -10px;
        width: 16px;
        height: 16px;
        background: #fff;
        border-right: 2px solid #111;
        border-bottom: 2px solid #111;
        transform: rotate(45deg);
      }

      .number11-delay-bubble[hidden] {
        display: none;
      }

      .number11-delay-title {
        margin: 0 28px 8px 0;
        font-size: 16px;
        font-weight: 700;
      }

      .number11-delay-text {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
      }

      .number11-delay-text a {
        color: inherit;
        text-decoration: underline;
        font-weight: 600;
      }

      .number11-delay-close {
        position: absolute;
        top: 8px;
        right: 10px;
        border: 0;
        background: transparent;
        color: #111;
        font-size: 24px;
        line-height: 1;
        cursor: pointer;
      }

      @media screen and (max-width: 749px) {
        #number11-aop-delay-notice {
          right: 14px;
          bottom: 14px;
        }

        .number11-delay-bubble {
          width: min(300px, calc(100vw - 28px));
        }
      }
    </style>

    <div class="number11-delay-bubble" role="status">
      <button
        type="button"
        class="number11-delay-close"
        aria-label="Close notice"
      >
        &times;
      </button>

      <p class="number11-delay-title">
        Worldwide delivery & support
      </p>

      <p class="number11-delay-text">
        Dear buyers, we ship worldwide. Please check our
        <a href="/pages/faq">FAQ</a>
        for taxes, shipping and delivery times. If anything is unclear,
        feel free to contact us anytime through our
        <a href="/pages/contact">Contact page</a>.
      </p>
    </div>

    <button
      type="button"
      class="number11-delay-trigger"
      aria-label="View worldwide delivery information"
      aria-expanded="true"
    >
      !
    </button>
  `;

  document.body.appendChild(wrapper);

  const bubble = wrapper.querySelector('.number11-delay-bubble');
  const trigger = wrapper.querySelector('.number11-delay-trigger');
  const close = wrapper.querySelector('.number11-delay-close');

  if (!bubble || !trigger || !close) return;

  if (sessionStorage.getItem('number11AopDelayNoticeClosed') === 'true') {
    bubble.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  trigger.addEventListener('click', function () {
    const isHidden = bubble.hidden;

    bubble.hidden = !isHidden;
    trigger.setAttribute('aria-expanded', isHidden ? 'true' : 'false');

    if (isHidden) {
      sessionStorage.removeItem('number11AopDelayNoticeClosed');
    }
  });

  close.addEventListener('click', function () {
    bubble.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    sessionStorage.setItem('number11AopDelayNoticeClosed', 'true');
  });
});